export const stats = {
  hp: {
    name: 'HP',
    color: '#FF5959'
  },
  attack: {
    name: 'Atk',
    color: '#F5AC78'
  },
  defense: {
    name: 'Def',
    color: '#FAE078'
  },
  'special-attack': {
    name: 'Sp.Atk',
    color: '#9DB7F5'
  },
  'special-defense': {
    name: 'Sp.Def',
    color: '#A7DB8D'
  },
  speed: {
    name: 'Speed',
    color: '#FA92B2'
  }
}
